//@flow
import _, { isBoolean } from 'lodash';
import * as React from 'react';
import { TableHeaderColumn } from 'react-bootstrap-table';
import connect from 'react-redux/es/connect/connect';
import ListagemPage from '../../components/templates/ListagemPage';
import { tableHelper } from '../../helpers/tableHelper';
import withAbility from '../../hoc/withAbility';
import { mapaProdutosService } from '../../services/mapaProdutos.service';
import TopoTitleComponente from '../Topo/TopoTitleComponente';
import MapaProdutosCrudListFilter from './MapaProdutosCrudListFilter';

const endPoint = '/mapaProdutos/novo/';
const endPointView = '/mapaProdutos/';
class MapaProdutosCrudList extends React.PureComponent<{}, State> {
  constructor(props) {
    super(props);

    const isSudo = props.user && props.user.perfis.includes('SUDO');

    this.columns = [
      {
        path: 'id',
        title: 'Identificador',
        isKey: true,
        dataSort: false,
        className: 'txtBold',
        hidden: true,
      },
      {
        path: 'pontoAtendimentoNome',
        title: 'Ponto de Atendimento',
        isKey: false,
        dataSort: false,
        className: 'txtBold',
      },
      ...(isSudo
        ? [
            {
              path: 'clienteNomeFantasia',
              title: 'Cliente',
              isKey: false,
              dataSort: false,
            },
          ]
        : []),

      {
        path: 'ativo',
        title: 'Ativo',
        isKey: false,
        yesNo: true,
        dataSort: false,
      },
    ];

    const fields = this.columns.map((col) => col.path);
    const labels = this.columns.map((col) => col.title);

    this.state = {
      labels,
      fields,
    };
  }

  handleRowClick = (row: e) => {
    if (this.props.ability.can('update', 'MapaProdutos')) {
      this.props.history.push(endPointView + row.id);
    }
  };

  handleNewButton = (row: e) => {
    this.props.history.push(endPoint);
  };
  render() {
    const fields = this.state.fields;

    const tableColumn = _.map(this.columns, (column, index) => (
      <TableHeaderColumn
        key={index}
        dataField={column.path}
        dataFormat={tableHelper.renderCustom}
        formatExtraData={column}
        isKey={column.isKey}
        dataSort={column.dataSort}
        hidden={column.hidden}
        width={column.width}
        className={column.classname}
      >
        {column.title}
      </TableHeaderColumn>
    ));

    let filter = {
      extension: this.props.extension
        ? this.props.extension
        : this.props.user.extension,
    };

    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle="Mapa de Produtos"
          subTitle=" "
          canBack={false}
        />
        <ListagemPage
          newButtonActionClick={() => {
            this.props.history.push('/mapaProdutos/novo');
          }}
          delete={() => {}}
          service={mapaProdutosService}
          showNewButton={this.props.ability.can('create', 'MapaProdutos')}
          labelNewButton="Novo Mapa de Produtos"
          defaultOrder={'nome'}
          defaultDirection={'asc'}
          defaultFilter={filter}
          onRowClick={this.handleRowClick}
          FormFilter={MapaProdutosCrudListFilter}
          fields={fields}
          array={'mapaProdutoss'}
        >
          {tableColumn}
        </ListagemPage>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user,
  };
}

export default connect(mapStateToProps)(withAbility(MapaProdutosCrudList));
